import { ComponentPropsWithoutRef, FC, ReactNode } from "react";

type ButtonProps = {
  label: ReactNode;
  variant: "primary" | "secondary";
} & ComponentPropsWithoutRef<"button">;

const Button: FC<ButtonProps> = ({ label, variant, ...otherProps }) => {
  if (variant === "primary") {
    return (
      <div>
        <button
          className={`flex items-center justify-center gap-[8px] w-full border border-[#E9E9E9] rounded-[8px] text-[16px] text-primaryDark-0 px-[32px] py-[16px] font-semibold font-raleway`}
          {...otherProps}
        >
          {label}
        </button>
      </div>
    );
  }

  return (
    <div>
      <button
        className={`flex items-center justify-center gap-[8px] w-full bg-primaryDark-0 border border-primaryDark-0 rounded-[8px] text-[16px] text-text-1000 px-[32px] py-[16px] font-semibold font-raleway`}
        {...otherProps}
      >
        {label}
      </button>
    </div>
  );
};

export default Button;
